import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BrokerButton.css';

type TBrokerButtonProps = {
  children: string;
  onClick: () => void;
};

export const BrokerButton: React.FC<TBrokerButtonProps> = ({ children, onClick }) => {
  return (
    <div className={styles['wrapper']}>
      <Button fullWidth onClick={onClick}>
        {children}
      </Button>
    </div>
  );
};
